import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

const propTypes = {
    columnProps: PropTypes.shape({
        rest: PropTypes.shape({
            onClick: PropTypes.func,
        }),
    }),
};

const defaultProps = {
    columnProps: {
        rest: {
            onClick: Function,
        },
    },
};

/**
 * This is to be used within a React Table
 */
function ViewCell({
    columnProps: {
        rest: { onClick },
    },
}) {
    return (
        <Row>
            <Col md={12} className="text-center table-buttons">
                <button className="btn-view" id="view-btn" value="view" onClick={onClick}>
                    View
                </button>
            </Col>
        </Row>
    );
}

ViewCell.propTypes = propTypes;
ViewCell.defaultProps = defaultProps;

export default ViewCell;
